/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReportingSharedService} from './reporting-shared.service';
import {ReportingSharedComponent} from './reporting-shared/reporting-shared.component';
import {ButtonModule} from "primeng/button";

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [ReportingSharedComponent],
  exports: [ReportingSharedComponent]
})
export class ReportingSharedModule {
  static forRoot(): ModuleWithProviders<ReportingSharedModule> {
    return {
      ngModule: ReportingSharedModule,
      providers: [ReportingSharedService]
    }
  }
}
